import type { Crumb } from "@/components/base/Breadcrumb";
import Breadcrumb from "@/components/base/Breadcrumb";

interface PageHeaderProps {
  title: string;
  subtitle: string;
  crumbs: Crumb[];
}

export default function PageHeader({ title, subtitle, crumbs }: PageHeaderProps) {
  return (
    <div className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-8 md:px-6 md:py-12">
        <Breadcrumb items={crumbs} />
        <h1 className="mt-4 text-2xl font-bold tracking-wide text-foreground-950 md:text-4xl">
          {title}
        </h1>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          {subtitle}
        </p>
      </div>
    </div>
  );
}